<script setup lang="ts">
import { useGlobalStore } from '~/stores/global';

import type { CatalogInApp } from '~/interfaces/app';
import { useMediaQueryStore } from '~/stores/mediaQuery';
const globalStore = useGlobalStore();
const mediaStore = useMediaQueryStore();
const router = useRouter();
const isTablet = computed(() => mediaStore.isTablet || mediaStore.isMobile);
defineProps({
  catalog: {
    type: Object,
    required: true,
  },
  selectedBase: {
    type: Object,
    required: true,
  },
});
const emit = defineEmits(['clickCategories', 'closeMenu', 'search']);

const allCatalog = computed(() => {
  return {
    title: 'Весь каталог',
    url: 'catalog/',
  };
});
const allCatalogClick = () => {
  router.push('/' + allCatalog.value.url);
};

function mouseHover(item: CatalogInApp) {
  const isDesktop = window.matchMedia('(min-width: 1280px)').matches;
  if (isDesktop) {
    emit('clickCategories', item);
  }
}
</script>
<template>
  <div class="base-level">
    <MenuCatalogHeader
      title="Каталог"
      @close="globalStore.setMenuOpen(false)"
      @search="emit('search')"
    />
    <ul
      itemscope=""
      itemtype="http://schema.org/SiteNavigationElement"
      class="menu-list l-bottom"
    >
      <MenuCatalogItem
        v-for="(item, index) in catalog"
        :key="index"
        :item="item"
        :is-tablet="isTablet"
        show-arrow
        grey-hover
        :is-grey="item.title === selectedBase.title"
        @click="emit('clickCategories', item)"
        @mouseenter="mouseHover(item)"
      />
      <MenuCatalogItem
        :is-tablet="isTablet"
        show-arrow
        grey-hover
        :item="allCatalog"
        last
        @click="isTablet && allCatalogClick()"
      />
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.base-level {
  width: 100vw;
  height: calc(100vh - 60px);
  overflow-y: auto;
  @include xl-block {
    min-width: 285px;
    max-width: 285px;
    width: 285px;
    padding: 12px 12px 0;
    padding-bottom: 40px;
    text-align: left;
    border-right: 1px solid #e7e7e7;

    overflow-y: auto;
    height: calc(100vh - 140px);
  }

  .menu-list {
    display: grid;
    padding: 0 12px;
    @include xl-block {
      padding: 0;
    }
  }
}
.l-bottom {
  margin-bottom: 14vh;
  @include xl-block {
    margin-bottom: 0;
  }
}
</style>
